import { env } from '../env';

const baseUrlApi = env.REACT_APP_API_SERVER;
export const apiVersionRequest = async () => {
    const url = baseUrlApi + 'Version';
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
                'Accept-Language': 'es'
            }
        });
        return response;
    } catch (error) {
        const response = { status: -1, text: 'GetApiVersion Error' };
        return response;
    }
};
